<template>
  <div class="location relative " style="z-index: 9999999999;">
    <!-- <v-select
      label="Select"
      :items="['California', 'Colorado', 'Florida', 'Georgia', 'Texas', 'Wyoming']"
    ></v-select> -->
    <!-- {value: 0, name: 'KIll one'}, {value: 1, name: 'KIll two'} -->
    <nova-select
      :title="title"
      :items="items"
      class="m-b-2"
      v-model="val"
    ></nova-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  // name: "NotificationSelect",
  data() {
    return{  }
  },
  props: {
    value: {
      default: null,
    },
    title: {
      default: null,
    },
    items: {
      default: [
        'Всем',
        'Родителям',
        'Ученикам',
      ],
    },
  },
  created() {
    this.val = 0;
  },
  mounted(){
    // this.value = 0
    
  },
  methods: {
    change(e) {},
  },
  computed: {
    // ...mapState(["courses"]),
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style lang="scss">
.location {
  select {
    padding: 5px 5px;
    width: 100%;
    height: 34px;
    border-radius: 10px;
    margin-bottom: 15px;
  }
}
</style>
